export const storeStaffList = (state, staffList) => {
  state.staffList = [...staffList];
};
